module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 128\"><rect class=\"background\" x=\"0\" y=\"0\" width=\"100%\" height=\"100%\" fill=\"transparent\"></rect><text x=\"10\" y=\"82.5\" width=\"5\" font-family=\"Open Sans\" font-weight=\"300\" font-size=\"80px\" fill=\"#6ab2c8\"> Digital X-Ray </text></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/xray.svg
// module id = 541
// module chunks = 1